import Offer from "../Models/Offer"
import OfferProducts from "../Models/OfferProducts"
import Response from "../../../Responses/Response"
import InfoMailRequest from "../Requests/InfoMailRequest"
import { PackageType } from "../Enums/PackageType"

class API
{
    public static async getOffersAsync(customerType: number, isCovered: boolean): Promise<Response<Offer[]>>
	{
		if (process.env.NODE_ENV === "development" && (process.env.REACT_APP_HOST === "" || process.env.REACT_APP_HOST === undefined))
		{
			return {
				success: true,
				errors: [],
				data: [
					{
						id: "1",
						name: "",
						ad_line_1: "",
						ad_line_2: "",
						ad_line_3: "",
						ad_speed: "10",
						ad_title: "",
						ad_subtitle: "al mese",
						background_color: "blu",
						description_color: "",
						connection_type: "",
						package_type: PackageType.Package,
						is_promo: false,
						image_url: "",
						price_color: "",
						ad_price: "10 €",
						figurative_price: 10,
						vat_price: 10
						
					},
                    {
						id: "2",
						name: "",
						ad_line_1: "",
						ad_line_2: "",
						ad_line_3: "",
						ad_speed: "10",
						ad_title: "",
						ad_subtitle: "al mese",
						background_color: "blu",
						description_color: "",
						connection_type: "",
						package_type: PackageType.Package,
						is_promo: false,
						image_url: "",
						price_color: "",
						ad_price: "10 €",
						figurative_price: 10,
						vat_price: 10
					},
                    {
						id: "3",
						name: "",
						ad_line_1: "",
						ad_line_2: "",
						ad_line_3: "",
						ad_speed: "10",
						ad_title: "",
						ad_subtitle: "al mese",
						background_color: "blu",
						description_color: "",
						connection_type: "",
						package_type: PackageType.Package,
						is_promo: false,
						image_url: "",
						price_color: "",
						ad_price: "10 €",
						figurative_price: 10,
						vat_price: 10
					}
				]
			}
		}
		else
		{
			let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/all`, {
				method: 'POST',
				body: JSON.stringify({
					"customerTypeId": customerType,
					"isCovered": isCovered
				}),
				headers: {
					"Content-type": "application/json; charset=UTF-8"
				}
			})
			return await res.json()
		}
	}

	public static async getPackageProductsAsync(packageId: string): Promise<Response<OfferProducts[]>>
	{
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/${packageId}/ads`, {
			method: 'GET',
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return await res.json()
	}

	public static async getPackage(packageId: string, customerTypeId: number): Promise<Response<Offer>>
	{
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/packages/${packageId}/fetch/${customerTypeId}`, {
			method: 'GET',
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})
		return await res.json()
	}

	public static async sendInfoMail(request: InfoMailRequest): Promise<boolean>
	{
		let res = await fetch(`${process.env.REACT_APP_HOST}/api/customers/info-mail`, {
			method: 'PUT',
			body: JSON.stringify(request),
			headers: {
				"Content-type": "application/json; charset=UTF-8",
				"Accept": "application/json"
			}
		})

		return res.ok
	}
}

export default API